var _path, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconWeatherCloudy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 41,
    viewBox: "0 0 67 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.3204 26.2891C55.478 26.2891 61.2803 20.4868 61.2803 13.3291C61.2803 6.17153 55.478 0.369141 48.3204 0.369141C41.1627 0.369141 35.3604 6.17153 35.3604 13.3291C35.3604 20.4868 41.1627 26.2891 48.3204 26.2891Z",
    fill: "url(#paint0_linear_755_1586)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M46 40.6295C51.89 40.6295 56.66 35.8595 56.66 29.9695C56.66 24.0795 51.89 19.3095 46 19.3095C45.96 19.3095 45.93 19.3095 45.89 19.3095C44.94 10.8095 37.73 4.18945 28.98 4.18945C22.06 4.18945 16.12 8.31945 13.45 14.2395C13.37 14.2395 13.28 14.2395 13.2 14.2395C5.91 14.2295 0 20.1395 0 27.4295C0 34.7195 5.91 40.6295 13.2 40.6295",
    fill: "#D7D7D7"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M60.2201 40.6283C63.9201 40.6283 66.9201 37.6283 66.9201 33.9283C66.9201 30.2283 63.9201 27.2283 60.2201 27.2283C60.2001 27.2283 60.1701 27.2283 60.1501 27.2283C59.5501 21.8883 55.0301 17.7383 49.5301 17.7383C45.1901 17.7383 41.4501 20.3283 39.7801 24.0483C39.7301 24.0483 39.6701 24.0483 39.6201 24.0483C35.0401 24.0483 31.3301 27.7583 31.3301 32.3383C31.3301 36.9183 35.0401 40.6283 39.6201 40.6283",
    fill: "url(#paint1_linear_755_1586)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_755_1586",
    x1: 39.1604,
    y1: 22.4991,
    x2: 57.4904,
    y2: 4.16914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDB727"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCD22"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_755_1586",
    x1: 38.7501,
    y1: 43.1883,
    x2: 59.0701,
    y2: 22.8583,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0E8F8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E1EEF9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconWeatherCloudy);
export default __webpack_public_path__ + "static/media/icon-weather-cloudy.d3b0282c1ef875bc12c5449ecbe27e17.svg";
export { ForwardRef as ReactComponent };